// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationSettingsPanel_panel__Xy3yV {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
}

.NotificationSettingsPanel_panel__Xy3yV h2,
.NotificationSettingsPanel_panel__Xy3yV h3 {
  margin: 0 0 12px;
  color: #1f2f3d;
}

.NotificationSettingsPanel_formRow__PnTs4 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.NotificationSettingsPanel_fieldGroup__cba73 {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 220px;
  flex: 1 1 220px;
}

.NotificationSettingsPanel_fieldLabel__3M6fc {
  color: #355061;
  font-size: 0.86rem;
  font-weight: 600;
}

.NotificationSettingsPanel_formRow__PnTs4 input,
.NotificationSettingsPanel_formRow__PnTs4 select {
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #c8d5e1;
  border-radius: 8px;
  background: #ffffff;
}

.NotificationSettingsPanel_tableWrap__u3ebb {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #d8e1e8;
  border-radius: 10px;
}

.NotificationSettingsPanel_table__ZXdMN {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
}

.NotificationSettingsPanel_table__ZXdMN thead tr {
  background: #34495e;
  color: #ecf0f1;
}

.NotificationSettingsPanel_table__ZXdMN th,
.NotificationSettingsPanel_table__ZXdMN td {
  padding: 10px 12px;
  border-bottom: 1px solid #e5ecf2;
  text-align: left;
}

.NotificationSettingsPanel_table__ZXdMN tbody tr:nth-child(even) {
  background: #f8fbfd;
}

.NotificationSettingsPanel_actions__iv0Bd {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.NotificationSettingsPanel_button__RHLp4 {
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.88rem;
  cursor: pointer;
  background: #3498db;
  color: #ffffff;
}

.NotificationSettingsPanel_muted__5S8Mr {
  color: #607283;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/NotificationSettingsPanel.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".panel {\n  margin-top: 20px;\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);\n  padding: 16px;\n}\n\n.panel h2,\n.panel h3 {\n  margin: 0 0 12px;\n  color: #1f2f3d;\n}\n\n.formRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 220px;\n  flex: 1 1 220px;\n}\n\n.fieldLabel {\n  color: #355061;\n  font-size: 0.86rem;\n  font-weight: 600;\n}\n\n.formRow input,\n.formRow select {\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #c8d5e1;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.tableWrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid #d8e1e8;\n  border-radius: 10px;\n}\n\n.table {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n}\n\n.table thead tr {\n  background: #34495e;\n  color: #ecf0f1;\n}\n\n.table th,\n.table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e5ecf2;\n  text-align: left;\n}\n\n.table tbody tr:nth-child(even) {\n  background: #f8fbfd;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 12px;\n}\n\n.button {\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 0.88rem;\n  cursor: pointer;\n  background: #3498db;\n  color: #ffffff;\n}\n\n.muted {\n  color: #607283;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `NotificationSettingsPanel_panel__Xy3yV`,
	"formRow": `NotificationSettingsPanel_formRow__PnTs4`,
	"fieldGroup": `NotificationSettingsPanel_fieldGroup__cba73`,
	"fieldLabel": `NotificationSettingsPanel_fieldLabel__3M6fc`,
	"tableWrap": `NotificationSettingsPanel_tableWrap__u3ebb`,
	"table": `NotificationSettingsPanel_table__ZXdMN`,
	"actions": `NotificationSettingsPanel_actions__iv0Bd`,
	"button": `NotificationSettingsPanel_button__RHLp4`,
	"muted": `NotificationSettingsPanel_muted__5S8Mr`
};
export default ___CSS_LOADER_EXPORT___;
